import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  HeroContainer,
  HowItWorksContainer,
  PricingTableContainer,
  CallToActionContainer,
  TestimonialsContainer,
  WhyHomelightContainer,
  ClientFaqContainer,
  ContactModalContainer,
} from '../../containers/cash-offer';

import { submitContactForm } from '../../api/contact-form/contact-api';
import { SITE_TYPE } from '../../utils/site-type-validator';

import '../common.scss';
import './cash-offer-layout.scss';

const Layout = (props) => {
  const {
    title,
    location,
    header,
    footer,
    heroContainer,
    howItWorksContainer,
    pricingTableContainer,
    callToActionContainer,
    testimonialsContainer,
    whyHomelightContainer,
    clientFaqContainer,
    metadata,
  } = props;
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [pricingTableVisible, setPricingTableVisible] = useState(false);

  useEffect(() => {
    if (contactModalOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [contactModalOpen]);

  return (
    <div className="layout-container">
      {header}
      <div className="on-main-container">
        <ContactModalContainer
          isOpen={contactModalOpen}
          openModalHandler={setContactModalOpen}
          submitContactForm={submitContactForm}
          location={location}
          siteType={SITE_TYPE.CASH_OFFER}
          title={title}
        />
        {heroContainer || (
          <HeroContainer
            metadata={metadata.cashOffer.hero}
            siteType={SITE_TYPE.CASH_OFFER}
            title={title}
            openModalHandler={setContactModalOpen}
            submitContactForm={submitContactForm}
          />
        )}
        {howItWorksContainer || <HowItWorksContainer metadata={metadata.cashOffer.howItWorks} title={title} />}
        {pricingTableVisible && (pricingTableContainer || <PricingTableContainer />)}
        {callToActionContainer || (
          <CallToActionContainer metadata={metadata.cashOffer.callToAction} openModalHandler={setContactModalOpen} />
        )}
        {testimonialsContainer || <TestimonialsContainer metadata={metadata.cashOffer.testimonials} title={title} />}
        {whyHomelightContainer || <WhyHomelightContainer metadata={metadata.cashOffer.whyHomelight} title={title} />}
        {clientFaqContainer || (
          <ClientFaqContainer
            title={title}
            metadata={metadata.cashOffer.clientFAQ}
            openModalHandler={setContactModalOpen}
          />
        )}
      </div>
      {footer}
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

Layout.defaultProps = { children: null, location: null };

export default memo(Layout);
